import { render, staticRenderFns } from "./selectedList.vue?vue&type=template&id=2cd95664&"
import script from "./selectedList.vue?vue&type=script&lang=ts&"
export * from "./selectedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports